import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
import { ContentBlock } from "./components/ContentBlock";
import { StickyIconBlock } from "./components/StickyIconBlock";
import styles from "./styles.pcss";
import { DEFAULT_APP_BLOCK } from "./constants";
var cn = classNames.bind(styles);
// todo: Необходим рефакторинг стилей, возможно с привлечением дизайнера для понимания правильных брейкпоинтов
var _AppBlock = function _AppBlock(_ref) {
  var stickyImageUrl = _ref.stickyImageUrl,
    phoneImageUrl = _ref.phoneImageUrl,
    title = _ref.title,
    description = _ref.description,
    iconUrl = _ref.iconUrl,
    children = _ref.children,
    color = _ref.color,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type;
  var isCollapsed = type === 'collapsed';
  return /*#__PURE__*/React.createElement("div", {
    className: cn('app', isCollapsed && 'collapsed', color, className),
    "data-t-id": "components-AppBlock"
  }, stickyImageUrl && !isCollapsed && /*#__PURE__*/React.createElement(StickyIconBlock, {
    className: cn('sticky-img'),
    stickyImageUrl: stickyImageUrl
  }), /*#__PURE__*/React.createElement(ContentBlock, {
    description: description,
    iconUrl: iconUrl,
    title: title
  }, children), /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cn('app-phone'),
    src: phoneImageUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('app-store')
  }, children));
};
export var AppBlock = compose(enhancedConnect({
  title: PropTypes.string,
  iconUrl: PropTypes.string,
  description: PropTypes.string,
  phoneImageUrl: PropTypes.string,
  stickyImageUrl: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  type: PropTypes.oneOf(['collapsed', 'default'])
}), withAutoMetric.Container(function (_ref2) {
  var title = _ref2.title;
  return {
    name: 'AppBlock',
    title: title
  };
}))(_AppBlock);
AppBlock.defaultProps = {
  stickyImageUrl: DEFAULT_APP_BLOCK.stickyImageUrl,
  phoneImageUrl: DEFAULT_APP_BLOCK.phoneImageUrl,
  iconUrl: DEFAULT_APP_BLOCK.iconUrl
};